import classNames from 'classnames';
import React, {ReactNode} from 'react';

export interface BufferOptionsItemProps {
  className?: string;
  children?: ReactNode;
}

export default function BufferOptionsItem(props: BufferOptionsItemProps): JSX.Element {
  return <div className={classNames('buffer-options-item', props.className)}>{props.children}</div>;
}
